import * as types from "../ActionTypes/actionTypes.js";
import { CALL_API } from "../middleware/api";

export function getGroupReportLookup(listName) {
  const options = {
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    method: "GET",
  };
  let endpoint = "applicationlookups/getlist/" + listName;
  return {
    [CALL_API]: {
      endpoint: endpoint,
      authenticated: true,
      config: options,
      types: [types.GET_REPORT_GROUP_LOOKUP_REQUEST, types.GET_REPORT_GROUP_LOOKUP_SUCCESS, types.GET_REPORT_GROUP_LOOKUP_FAILURE],
    },
  };
}



// WEBPACK FOOTER //
// ./src/reduxRelated/actions/groupReportActions.js